import React from 'react';
import Measure from "react-measure";
import { Row, Col } from "react-bootstrap";
import SkillDetailView from './details/SkillDetailsView';
import Button from "src/components/button";
import Slider from "src/components/slider";
import InfiniteScroll from 'src/components/infiniteScroll';
import DeleteSkillContainer from './components/delete/DeleteSkillContainer';
import SkillItem from './components/Skills/SkillItem';
import userRoleService from 'src/services/userRoles.service';

import _ from "lodash";
import cx from "classnames";
import styles from "./Styles.module.scss";
import PermissionDenined from 'src/components/permissionDenied';


class SkillView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      height: 300,
      selection: null,
      deleteField: null,
      creating: false,
      deleting: false,
      errors: {},
      skills: [],
      selected: "",
    };

    this._handleFieldSelection = this._handleFieldSelection.bind(this);
    this._handleFieldChange = this._handleFieldChange.bind(this);
    this._handleDeleteClick = this._handleDeleteClick.bind(this);
    this._handleAddFieldClick = this._handleAddFieldClick.bind(this);
    this._handleResetClick = this._handleResetClick.bind(this);
    this._handleSaveClick = this._handleSaveClick.bind(this);
    this._onDeleteSuccess = this._onDeleteSuccess.bind(this);
    this.renderSkills = this.renderSkills.bind(this);
  }

  componentDidMount() {
    this.props.fetchSkills(0);
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.skills, this.props.skills)) {
      this.setState({
        skills: this.props.skills,
      });

      if (!this.state.selection) {
        this.setState({
          selection: this.props.skills[0],
          selected: this.props.skills[0],
        });
      } else {
        const selection = _.find(this.props.skills, { id: this.state.selection.id });
        this.setState({
          selection: selection,
        });
      }
    }
  }

  _handleAddFieldClick() {
    this.setState({
      selection: {
        name: "Untitled",
        subSkills: [],
      },
      creating: true,
      selected: "",
    });
  }

  _handleFieldSelection(item) {
    this.setState({
      selection: item,
      creating: false,
      errors: {},
      selected: item,
    });
  }

  _handleFieldChange(field, value) {
    this.setState({
      selection: {
        ...this.state.selection,
        [field]: value,
      },
      errors: {},
    });
  }

  _handleDeleteClick(field) {
    this.setState({
      deleting: true,
      deleteField: field,
    });
  }

  _handleResetClick() {
    const { creating, skills, selection } = this.state;

    let selectedSkill = null;

    if (creating) {
      selectedSkill = skills[0] || null;
    } else {
      selectedSkill = skills.find((skill) => skill.id === selection?.id) || null;
    }

    //reset the subSkills
    selectedSkill = {
      ...selectedSkill,
      subSkills: selectedSkill?.children
    }

    this.setState({
      selection: selectedSkill,
      creating: false,
    });
  }

  _validateSkill(selection) {
    const errors = {};

    const parentSkill = _.trim(selection?.name);
    if (!parentSkill) {
      errors.parentSkill = "Please enter a skill name.";
    }

    const subSkills = selection?.subSkills || selection?.children;
    const invalidSubSkills = (subSkills || []).filter(
      (sub) => !_.trim(sub?.name),
    );
    if (invalidSubSkills.length > 0) {
      errors.subSkill = "Please enter a skill name.";
    }

    return errors;
  }

  _handleSaveClick() {
    const { creating, selection } = this.state;
    const errors = this._validateSkill(selection);

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    const name = _.trim(selection?.name) || "Untitled";
    const subSkillSource = selection?.subSkills || selection?.children || [];

    const subSkills = subSkillSource.map((subskill) => ({
      id: subskill.id,
      name: _.trim(subskill.name) || "Untitled",
      ...(subskill.isNew ? { isNew: true } : {}),
    }));

    const skillPayload = { name, subSkills };

    if (creating) {
      this.props.createSkill(skillPayload).then((res) => {
        this.setState({
          creating: false,
          selection: res.payload,
          errors: {},
        });
      });
    } else {
      const id = selection?.id;
      this.props.updateSkill(id, skillPayload);
    }
  }

  _onDeleteSuccess(id) {
    var selection =
      this.state.skills && this.state.skills.length > 0
        ? this.state.skills[0]
        : null;

    const skills = (this.state.skills || []).filter((skill) => skill.id !== id);

    this.setState({
      deleting: false,
      deleteField: null,
      selection: selection,
      skills: skills,
    });
  }

  handleFetchMoreSkills(page) {
    this.props.fetchSkills(page);
  }

  renderSkills() {
    return (
      <InfiniteScroll
        loading={this.props.loading}
        hasMore={this.props.pagination.currentPage < this.props.pagination.totalPages}
        loadMore={() => this.handleFetchMoreSkills(this.props.pagination.currentPage + 1)}
        loader={() => {
          return (
            <div className={cx(styles.loader)}>
              <p>loading...</p>
            </div>
          )
        }
        }
        children={
          <div>
            {this.props.skills.map((skill, i) => (
              <SkillItem
                key={skill.id}
                item={skill}
                index={i}
                onDelete={this._handleDeleteClick}
                selected={this.state.selected}
                onSelection={this._handleFieldSelection}
              />
            ))}
          </div>
        }
      />
    );
  }

  render() {
    if(!userRoleService.canAccessCoaching() || !userRoleService.canCreateCourse()) {
      return (
        <PermissionDenined />
      );
    }

    return (
      <div>
        <Measure
          bounds
          onResize={(contentRect) => {
            var height = contentRect.bounds.height;
            this.setState({
              height: height - 180,
            });
          }}
        >
          {({ measureRef }) => (
            <div ref={measureRef} className={styles.content}>
              <h1 className={styles.heading}>Skills</h1>
              <div className={styles.line} />
              <Row className={styles.body}>
                <Col
                  md={6}
                  className={styles.menus}
                  style={{ height: this.state.height }}
                >
                  <div
                    className={cx(styles.action, styles.add)}
                    onClick={this._handleAddFieldClick}
                  >
                    <i className="paperflite-add" /> add skills
                  </div>
                  {this.props.loading && _.size(this.props.skills) === 0 && (
                    <div className={cx(styles.loadingSkills)}>
                      Loading skills...
                    </div>
                  )}

                  {!this.props.loading && _.size(this.props.skills) > 0 && this.renderSkills()}                     
                </Col>
                <Col
                  md={6}
                  className={styles.menuDetails}
                  style={{ height: this.state.height }}
                >
                  {this.state.selection && (
                  
                    <SkillDetailView
                      item={this.state.selection}
                      onFieldChange={this._handleFieldChange}
                      creating={this.state.creating}
                      errors={this.state.errors}
                    />
                  )}
                </Col>
              </Row>
              <Row className={styles.actions}>
                <Col md={5} lg={5} xl={5} className={styles.buttonRow}>
                  <Button
                    text={
                      this.props.updating || this.props.creating
                        ? "Saving Changes..."
                        : "Save"
                    }
                    variant="primary"
                    disabled={this.props.updating || this.props.creating}
                    onClick={this._handleSaveClick}
                    icon="paperflite-tick"
                    className={styles.save}
                  />

                  <Button
                    text="Cancel"
                    variant="secondary"
                    className={styles.reset}
                    disabled={this.props.creating || this.props.updating}
                    onClick={this._handleResetClick}
                  />
                </Col>
              </Row>
            </div>
          )}
        </Measure>
        <Slider.Dialog
          width="23vw"
          show={this.state.deleting && this.state.deleteField}
        >
          <DeleteSkillContainer
            item={this.state.deleteField}
            onDeletion={this._onDeleteSuccess}
            onCancel={() => {
              this.setState({
                deleting: false,
                deleteField: null,
              });
            }}
          />
        </Slider.Dialog>
      </div>
    );
  }
}

export default SkillView;